// extracted by mini-css-extract-plugin
module.exports = {"wrapperPanel":"index_wrapperPanel__35WIX"};